import React, { useMemo } from "react";

function normalizeModelUrl(value) {
  if (!value) return null;
  const trimmed = String(value).trim();
  return trimmed || null;
}

export default function TreeModelViewer({ tree }) {
  const modelUrl = useMemo(
    () => normalizeModelUrl(tree?.three_d_model_url),
    [tree?.three_d_model_url]
  );
  const viewerUrl = useMemo(() => {
    if (!modelUrl) return null;
    const params = new URLSearchParams({ model: modelUrl });
    return `/darbots-viewer/viewer.html?${params.toString()}`;
  }, [modelUrl]);

  if (!viewerUrl) return null;

  return (
    <div className="tree-model-viewer">
      <div className="tree-model-viewer__frameWrap">
        <a
          className="tree-model-viewer__externalLink"
          href={viewerUrl}
          target="_blank"
          rel="noreferrer"
        >
          <img
            src="/darbots-3d-button.png"
            alt=""
            aria-hidden="true"
            className="tree-model-viewer__externalLinkImage"
          />
          <span className="tree-model-viewer__externalLinkLabel">Open Darbots 3D</span>
        </a>
        <iframe
          title="3D Tree Viewer"
          src={viewerUrl}
          className="tree-model-viewer__frame"
          loading="lazy"
        />
      </div>
    </div>
  );
}
